import styles from './calculatorOutputCard.module.scss';

export default function CalculatorOutputCard({
  label,
  value
}: {
  label: string;
  value: string | null;
}) {
  if (!value) return null;
  return (
    <div className={styles.calculatorOutputCard}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
}
